export default __webpack_public_path__ + "static/media/photo--lg--113.d533f1ca.jpg";